import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { UserRole } from '../../shared/types';
import { Table } from 'react-bootstrap';
import * as Site from '../../shared/Site';
import { Translate } from '../../shared/LanguageService';
import OrderStatusesIcons from '../statusicons/StatusIcons';
import OrderListTableCell from '../../components/common/OrderListTableCell';
import ProductPropertiesIcons from '../propertyIcons/ProductPropertiesIcons';

const DesktopOrderTable = ({ orders, userRole, productsToExclude, openModal }) => {
    return (
        <Table className="order-table table-nopadding " hover responsive>
            <thead>
                <th>{Translate('edited-orders/table/header/orderid')}</th>
                <th>{Translate('edited-orders/table/header/booked-date')}</th>
                <th>{Translate('edited-orders/table/header/ordered')}</th>
                <th>{Translate('edited-orders/table/header/address')}</th>
                <th>{Translate('edited-orders/table/header/postal-code')}</th>
                <th>{Translate('edited-orders/table/header/city')}</th>
                <th>{Translate('edited-orders/table/header/is-approved')}</th>
                <th>{Translate('edited-orders/table/header/is-Measured')}</th>
                <th>{Translate('edited-orders/table/header/extra')}</th>
                <th></th>
                <th></th>
                <th></th>
            </thead>
            <tbody>
                {orders.map((order: any, index: number) => {
                    const orderLink = `/orders/${order.orderId}/image`;

                    let rowClass = Site.getOrderCssClass(order.site);
                    if (order.isExpress) {
                        rowClass += ' express';
                    } else if (order.isExpressWeekend) {
                        rowClass += ' express-weekend';
                    } else if (order.isEarlyDelivery) {
                        rowClass += ' early-delivery';
                    }

                    return (
                        <tr className={rowClass} key={index}>
                            <OrderListTableCell clickable={true} navigateTo={orderLink}>
                                {order.orderCollectionNumber + ':' + order.orderNumber}
                            </OrderListTableCell>
                            <OrderListTableCell clickable={true} navigateTo={orderLink}>
                                {moment(order.bookingDate).format('L')}
                            </OrderListTableCell>
                            <OrderListTableCell clickable={true} navigateTo={orderLink}>
                                {order.productName}
                            </OrderListTableCell>
                            <OrderListTableCell clickable={true} navigateTo={orderLink}>
                                {order.addressLine1}
                            </OrderListTableCell>
                            <OrderListTableCell clickable={true} navigateTo={orderLink}>
                                {order.addressPostalNumber}
                            </OrderListTableCell>
                            <OrderListTableCell clickable={true} navigateTo={orderLink}>
                                {order.addressCity}
                            </OrderListTableCell>
                            <OrderListTableCell
                                clickable={true}
                                navigateTo={orderLink}
                                className={!order.isApproved ? 'red' : ''}
                            >
                                {order.isApproved && (
                                    <i className="material-icons">check_circle</i>
                                )}
                                {!order.isApproved && (
                                    <i className="material-icons">warning</i>
                                )}
                            </OrderListTableCell>
                            <OrderListTableCell
                                clickable={true}
                                navigateTo={orderLink}
                                className={!order.isPlanUploaded ? 'red' : ''}
                            >
                                {order.isMeasured && !order.isPlanUploaded && (
                                    <i className="material-icons">warning</i>
                                )}
                                {order.isMeasured && order.isPlanUploaded && (
                                    <i className="material-icons">check_circle</i>
                                )}
                            </OrderListTableCell>
                            <OrderListTableCell
                                clickable={
                                    !(
                                        order.photographerInstruction &&
                                        order.photographerInstruction.length > 0
                                    )
                                }
                                navigateTo={orderLink}
                            >
                                {order.photographerInstruction &&
                                    order.photographerInstruction.length > 0 && (
                                        <i
                                            className="btn btn-default"
                                            onClick={() => openModal(order)}
                                        >
                                            <i className="material-icons">info</i>
                                        </i>
                                    )}
                            </OrderListTableCell>
                            <OrderListTableCell clickable={true} navigateTo={orderLink}>
                                <ProductPropertiesIcons
                                    properties={userRole == UserRole.Photographer
                                        ? order.productProperties.filter((property) => {
                                            return property.value !== productsToExclude.find((x) => x === property.value);
                                        })
                                        : order.productProperties}
                                ></ProductPropertiesIcons>
                                {order.photographerIsEditor && (
                                    <span className="property-icons">
                                        <i
                                            className="material-icons"
                                            title={Translate(
                                                'order/photographer-is-editing/title'
                                            )}
                                        >
                                            edit
                                        </i>
                                    </span>
                                )}
                            </OrderListTableCell>
                            <OrderListTableCell clickable={true} navigateTo={orderLink}>
                                <OrderStatusesIcons
                                    orderStatuses={order.orderStatuses}
                                ></OrderStatusesIcons>
                            </OrderListTableCell>
                            <td>
                                {order.planOrderId && order.isMeasured && (
                                    <Link
                                        className="btn btn-default"
                                        to={`/orders/${order.planOrderId}/plan`}
                                    >
                                        {Translate(
                                            'edited-orders/table/button/go-to-measured-order'
                                        )}
                                    </Link>
                                )}
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </Table>
    );
};

export default DesktopOrderTable;
